import Page from "@/components/Page";
import PractitionerFavourite from "@/images/PractitionerFavourite";
import Group from "@/tpo/Group";
import B2CHeader from "@/tpo/header/B2CHeader";

import ListTemplate from "./ListTemplate";

export function PractitionerFavouriteToolbarFooter() {
  return (
    <Group alignItems="center" justifyContent="flex-end" width="100%">
      <Group
        gap={20}
        alignItems="center"
        justifyContent="flex-end"
        fontFamily="gilroyMedium"
        fontSize={14}
      >
        Practitioner favourite: <PractitionerFavourite />
      </Group>
    </Group>
  );
}

/** Shared shell for Find a Practitioner list tabs (practitioners, supported tests). */
export default function ExpertsListPage({
  header,
  subheader,
  filterSidebar,
  children,
  ...filteredContentProps
}) {
  return (
    <>
      <B2CHeader />
      <Page>
        <ListTemplate.Switcher>
          <ListTemplate.Header header={header} subheader={subheader} />
        </ListTemplate.Switcher>
        <ListTemplate.Container>
          <ListTemplate.FilteredContent filterSidebar={filterSidebar} {...filteredContentProps}>
            {children}
          </ListTemplate.FilteredContent>
        </ListTemplate.Container>
      </Page>
    </>
  );
}
